import { RestrictiveCourses } from "../../generated/graphql"
import { getBookingRestrictions } from "../common/helpers"
import { TableDataType } from "./CoursesTable"

export const shouldShowMemberDiscount = (courseData: TableDataType["items"]) => {
    const hasMemberDiscount = courseData?.some((course) => course?.coursePrice[0]?.discount !== null)

    return hasMemberDiscount ?? false
}

// Spalte und Legende „Buchungsbeschränkung“: per altem URL-Parameter restrictiveCourses
// angefordert oder mindestens ein angezeigter Kurs hat gerade eine Beschränkung.
export const shouldShowRestrictions = (restrictiveCourses: Array<RestrictiveCourses> | null | undefined, courseData: TableDataType["items"]) => {
    const requested = restrictiveCourses?.some((restriction) =>
        [RestrictiveCourses.MembersOnly, RestrictiveCourses.PrerequisiteCourses, RestrictiveCourses.All].includes(restriction)
    )
    if (requested) return true

    return (
        courseData?.some((course) => {
            const { membersOnly, prerequisites } = getBookingRestrictions(course?.bookingRestriction)
            return membersOnly || prerequisites
        }) ?? false
    )
}
